import { useState } from 'react';
import { timelineFilters, timelineNodes } from '@/mocks/home';
import SectionHeading from '@/pages/home/components/SectionHeading';

const stageDot: Record<string, string> = {
  源头: 'bg-accent-500',
  发酵: 'bg-primary-500',
  回应: 'bg-secondary-500',
  收尾: 'bg-foreground-400',
};

const stageBadge: Record<string, string> = {
  源头: 'bg-accent-100 text-accent-900',
  发酵: 'bg-primary-100 text-primary-900',
  回应: 'bg-secondary-100 text-secondary-900',
  收尾: 'bg-background-200 text-foreground-600',
};

export default function TimelineSection() {
  const [filter, setFilter] = useState('全部');
  const nodes = filter === '全部' ? timelineNodes : timelineNodes.filter((node) => node.stage === filter);

  return (
    <section id="timeline" className="bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-24">
        <SectionHeading
          index="03"
          eyebrow="Timeline"
          title="来龙去脉时间线"
          desc="按源头、发酵、回应、收尾四个阶段把节点串起来，每个节点都标了它相对前一步改变了什么。"
        />

        <div className="mb-10 flex flex-wrap gap-2">
          {timelineFilters.map((item) => (
            <button
              key={item}
              type="button"
              onClick={() => setFilter(item)}
              className={
                filter === item
                  ? 'whitespace-nowrap rounded-full bg-foreground-950 px-4 py-2 text-sm text-background-50'
                  : 'whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600'
              }
            >
              {item}
            </button>
          ))}
        </div>

        <ol className="relative ml-1 space-y-9 border-l border-background-300 pl-8 md:ml-2 md:space-y-11 md:pl-12">
          {nodes.map((node) => (
            <li key={node.id} className="relative">
              <span
                className={`absolute top-1.5 h-3.5 w-3.5 rounded-full border-2 border-background-100 ${stageDot[node.stage]} -left-[2.4rem] md:-left-[3.4rem]`}
              />
              <div className="md:grid md:grid-cols-[180px_1fr] md:gap-8">
                <div className="mb-2 flex items-center gap-2 md:mb-0 md:block">
                  <span className="font-label text-xs text-foreground-500">{node.time}</span>
                </div>
                <div>
                  <span
                    className={`inline-flex rounded-full px-2.5 py-1 font-label text-[11px] ${stageBadge[node.stage]}`}
                  >
                    {node.stage}
                  </span>
                  <h3 className="mt-3 font-heading text-lg leading-snug text-foreground-950 md:text-xl">
                    {node.title}
                  </h3>
                  <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{node.desc}</p>
                </div>
              </div>
            </li>
          ))}
        </ol>

        {nodes.length === 0 ? (
          <p className="py-10 text-center text-sm text-foreground-500">该阶段暂无可展示的节点。</p>
        ) : null}
      </div>
    </section>
  );
}